import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.75 9.30964V4.16667C2.75 3.24619 3.49619 2.5 4.41667 2.5H9.55964C10.0017 2.5 10.4256 2.6756 10.7382 2.98816L17.1965 9.44649C17.8474 10.0974 17.8474 11.1526 17.1965 11.8035L12.0535 16.9465C11.4026 17.5974 10.3474 17.5974 9.69649 16.9465L3.23816 10.4882C2.92559 10.1756 2.75 9.75167 2.75 9.30964Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.91683 6.24998C6.91683 6.4801 6.73028 6.66665 6.50016 6.66665C6.27004 6.66665 6.0835 6.4801 6.0835 6.24998C6.0835 6.01986 6.27004 5.83331 6.50016 5.83331C6.73028 5.83331 6.91683 6.01986 6.91683 6.24998Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.41553 6.25H6.58219",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }, null, -1)
  ]))]))
}
export default { render: render }